import { useState } from "react";
import { PlaybackDeviceInfo } from "@videosdk.live/react-sdk/dist/types/deviceInfo";
import {
  SoundOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import {
  Button, Typography, Popover, Space, Row, Col, Divider, Progress, App, Flex
} from "antd";
import { useTranslation } from "react-i18next";
// @ts-ignore @TODO: investigate
import test_sound from "../../sounds/test_sound.mp3";
import useVideoStore from "../../hooks/useVideoStore";

const { Text } = Typography;

const SpeakersControls = ({ speakers }: { speakers: PlaybackDeviceInfo[] }) => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const {
    setSelectedSpeaker,
    selectedSpeaker,
    isMicrophonePermissionAllowed
  } = useVideoStore();
  const [audioProgress, setAudioProgress] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const testSpeakers = () => {
    const selectedSpeakerDeviceId = selectedSpeaker.id;
    if (selectedSpeakerDeviceId) {
      const audio = new Audio(test_sound);
      try {
        // @ts-ignore
        audio.setSinkId(selectedSpeakerDeviceId)
          .then(() => {
            audio.play();
            setIsPlaying(true);
            audio.addEventListener("timeupdate", () => {
              const progress = (audio.currentTime / audio.duration) * 100;
              setAudioProgress(progress);
            });
            audio.addEventListener("ended", () => {
              setAudioProgress(0);
              setIsPlaying(false);
            });
          });
      } catch (error) {
        // message.error(`${error}`);
      }
      audio.play().catch(error => {
        message.error(`Failed to set sinkId: ${error}`);
      });
    } else {
      message.error("Selected speaker deviceId not found.");
    }
  };

  return (
    <Popover
      content={(
        <Space direction="vertical" size={0}>
          {speakers.map(
            (item, index) => {
              return item?.kind === "audiooutput" && (
                <Button
                  key={item.deviceId}
                  type="text"
                  onClick={() => {
                    setSelectedSpeaker({ id: item?.deviceId, label: item?.label });
                  }}
                  block
                >
                  <Row gutter={8} style={{ width: "100%" }}>
                    <Col span={2}>
                      {selectedSpeaker?.label === item?.label && (
                        <CheckOutlined/>
                      )}
                    </Col>
                    <Col span={22} style={{ textAlign: "left" }}>
                      <Text ellipsis>
                        {item?.label ? item?.label : `Speaker ${index + 1}`}
                      </Text>
                    </Col>
                  </Row>
                </Button>
              );
            }
          )}

          <Divider style={{ margin: "8px 0" }}/>
          {speakers.length && (
            <Button
              type="text"
              onClick={testSpeakers}
              block
              style={{ justifyContent: "flex-start" }}
            >
              <Flex gap={10} align="center">
                <SoundOutlined/>
                {isPlaying ? (
                  <Progress percent={audioProgress} showInfo={false}/>
                ) : <span>Test Speakers</span>}
              </Flex>
            </Button>
          )}
        </Space>
      )}
      trigger="click"
      placement="topLeft"
    >
      <Button
        disabled={!isMicrophonePermissionAllowed}
        block
        style={{ display: "flex", alignItems: "center" }}
      >
        <Flex gap={10} style={{ width: "100%", color: "black", opacity: ".25" }}>
          <SoundOutlined />
          <Text ellipsis>
            {isMicrophonePermissionAllowed ? selectedSpeaker?.label : t("video.permissionNeeded")}
          </Text>
        </Flex>
      </Button>
    </Popover>
  );
};

export default SpeakersControls;
